import React, {createContext} from 'react';
import {currencyDetails} from './utils/currencyList';

interface Currency {
  _key: string;
  _type: string;
  currency: string;
  exchange_rates: ExchangeRate[];
  details: {
    country: string;
    currency_code: string;
    image: string;
    currency: {
      symbol: string;
      name: string;
      symbol_native: string;
      decimal_digits: number;
      rounding: number;
      code: string;
      name_plural: string;
    };
  };
}

interface ExchangeRate {
  _key: string;
  _type: string;
  base_currency: string;
  rate: number;
}

export const GlobalContext = createContext<{
  all_currencies: Currency[];
  baseCurrency: string;
  exchangeRates: {
    [key in string]: number;
  };
} | null>(null);

export function GlobalProvider({
  children,
  currencySettings,
}: {
  children: React.ReactNode;
  currencySettings: any;
}) {

  const exchangeRates = currencySettings.all_currencies.map((c: Currency) => {
    const currency = c.currency.split('-')[1];
    const exchangeRate = c.exchange_rates.find(
      (er: ExchangeRate) =>
        er.base_currency.split('-')[1] === currencySettings.baseCurrency,
    )?.rate;
    return {
      currency,
      rate: exchangeRate,
    };
  });
  const exchangeRatesMap = exchangeRates.reduce(
    (
      a: {currency: string; rate: number}[],
      v: {currency: string; rate: number},
    ) => ({
      ...a,
      [v.currency]: v.rate,
    }),
    {},
  );
  return React.createElement(
    GlobalContext.Provider,
    {
      value: {
        ...currencySettings,
        exchangeRates: exchangeRatesMap,
        all_currencies: currencySettings.all_currencies.map((c: Currency) => {
          const currency = c.currency.split('-')[1];
          return {
            ...c,
            currency: currency,
            exchange_rates: c.exchange_rates.map((er: ExchangeRate) => ({
              ...er,
              base_currency: er.base_currency.split('-')[1],
            })),
            details: currencyDetails.find(
              (currencyDetail) =>
                currencyDetail.country === c.currency.split('-')[0],
            ),
          };
        }),
      },
    },
    children,
  );
}
